module.exports = __webpack_public_path__ + "img/bml-iso-certs.fb06a7dd.jpeg";